export default "<h1>Installation 安装</h1>\n<p>语义化的矢量图形。</p>\n"